export const onFormUploaded = (applicant, fileDetails) => {
    let _applicant = JSON.parse(JSON.stringify(applicant));
    if (!_applicant.Documents) {
        _applicant.Documents = [];
    }
    _applicant.Documents.push(fileDetails.documentData);
    return _applicant;
};